export type MyStoreSettlementsTabsType =
  | 'received'
  | 'pending_settlement'
  | 'completed';

export const myStoreSettlementTabsConfig: Array<{
  key: MyStoreSettlementsTabsType;
  label: string;
}> = [
  {key: 'received', label: 'دریافت شده'},
  {key: 'pending_settlement', label: 'در انتظار تسویه'},
  {key: 'completed', label: 'تسویه شده'},
];

export const myStoreSettlementDisplayConfig = [
  {
    key: 'received',
    showHeader: true,
    headerText:
      'مبالغ سفارش‌های دریافت شده بعد از تامین و تحویل سفارش به حساب شما واریز می‌شوند.',
  },
  {
    key: 'pending_settlement',
    showHeader: true,
    headerText:
      'مبلغ سفارش‌های ارسال شده تا 48 ساعت بعد از تحویل سفارش به حساب شما واریز می‌شود و به شما اطلاع رسانی می‌شود.',
  },
  {
    key: 'completed',
    showHeader: false,
    headerText: ' ',
  },
] as const;
